import React, { Component } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Snackbar from "@material-ui/core/Snackbar";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GetProduct, DeleteStore } from "../../fetchs";

import { Grid } from "@material-ui/core";
import { ModalDetailprice } from "../Useful/Useful";

import DeleteIcon from "@material-ui/icons/Delete";
import AlertDialog from "../Prompt/alert-dialog.component";
import CircularProgress from "@material-ui/core/CircularProgress";

import "./product-list.styles.css";

const headCells = [
  { id: "number", numeric: false, disablePadding: true, label: "شماره" },
  { id: "pic", numeric: false, disablePadding: true, label: "نام فروشنده " },
  { id: "name", numeric: false, disablePadding: true, label: "حوزه قیمت" },
  { id: "name", numeric: false, disablePadding: true, label: "قیمت برای" },
  { id: "name", numeric: false, disablePadding: true, label: "مدل قیمت " },
  // { id: "brand", numeric: true, disablePadding: false, label: "قیمت" },
  { id: "brand", numeric: true, disablePadding: false, label: "هزینه ارسال" },
  // {
  //   id: "goodType",
  //   numeric: true,
  //   disablePadding: false,
  //   label: "قیمت همکار ",
  // },
  {
    id: "price",
    numeric: false,
    disablePadding: true,
    label: "تعداد موجود",
  },
  {
    id: "price",
    numeric: false,
    disablePadding: true,
    label: "وضعیت",
  },
  {
    id: "price",
    numeric: false,
    disablePadding: true,
    label: " هدیه",
  },
  { id: "tools", numeric: false, disablePadding: true, label: "تغییرات" },
];

export default class ProductList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 0,
      rowsPerPage: 20,
      rowsLength: 0,
      rows: [],
      brands: [],
      goodTypes: [],
      filterBrandId: "",
      filterGoodTypeId: "",
      alertDialog: false,
      deleteId: null,
      loading: false,
      openSnackbar: false,
      errorMessage: "",
    };
  }

  handleCloseSnackbar = () => {
    this.setState({ openSnackbar: false });
  };

  componentDidMount() {
    this.getProductsFromServer();
  }

  getProductsFromServer = () => {
    this.setState({ loading: true });
    GetProduct(this.props.match.params.productId)
      .then((response) => {
        this.setState({ loading: false });
        return response.json();
      })
      .then((responseJson) => {
        this.setState({
          rows: responseJson.storeViewModel,
          rowsLength: responseJson.count,
        });
      })
      .catch((error) => {
        this.setState({ loading: false });
        console.log(error);
      });
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, () => {
      this.getProductsFromServer();
    });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, page: 0 }, () => {
      this.getProductsFromServer();
    });
  };

  handleDelete = () => {
    this.setState({ alertDialog: false, loading: true });
    DeleteStore(this.state.deleteId)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status === 200)
          toast.success("قیمت محصول با موفقیت حذف شد");
        else toast.error("خطای حذف قیمت محصول");
        this.getProductsFromServer();
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  handlePrepareDelete = (id) => {
    this.setState({ deleteId: id, alertDialog: true });
  };

  handleCloseDialog = () => {
    this.setState({ alertDialog: false });
  };

  emptyRows = () =>
    this.state.rowsPerPage -
    Math.min(
      this.state.rowsPerPage,
      this.state.rowsLength - this.state.page * this.state.rowsPerPage
    );

  render() {
    return (
      <div className="root">
        <Paper className="paper">
          <Toolbar>
            <Grid item xs={12} sm={6}>
              <div className="title">
                {
                  <Typography variant="h6" id="tableTitle">
                    لیست قیمت ها
                  </Typography>
                }
              </div>
            </Grid>
          </Toolbar>
          <div className="tableWrapper">
            <Table
              className="table"
              aria-labelledby="tableTitle"
              size={"medium"}
            >
              <TableHead>
                <TableRow>
                  {headCells.map((headCell) => (
                    <TableCell
                      key={headCell.id}
                      align={"center"}
                      padding={headCell.disablePadding ? "none" : "default"}
                    >
                      <TableSortLabel active={false}>
                        {headCell.label}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.rows.map((row, index) => {
                  return (
                    <TableRow hover tabIndex={-1} key={index}>
                      <TableCell align="center">
                        {this.state.page * this.state.rowsPerPage + index + 1}
                      </TableCell>
                      <TableCell align="center">{row.adminName}</TableCell>
                      <TableCell align="center">
                        {row.storeType === 0
                          ? "شهر"
                          : row.storeType === 1
                          ? "استان"
                          : row.storeType === 2
                          ? "کشور"
                          : "ثبت نشده"}
                      </TableCell>
                      <TableCell align="center">
                        {row.storeType === 0
                          ? row.cityName
                          : row.storeType === 1
                          ? row.fullProvinceName
                          : row.storeType === 2
                          ? "---"
                          : "ثبت نشده"}
                      </TableCell>
                      <TableCell align="center">
                        <ModalDetailprice
                          buttonLabel="مدل قیمت"
                          title=" مدلهای قیمت"
                          storePrices={
                            row.storePrices
                              ? row.storePrices
                              : "مدل قیمت ثبت نشده است"
                          }
                        ></ModalDetailprice>
                      </TableCell>
                      {/* <TableCell align="center">{row.price}</TableCell> */}
                      <TableCell align="center">{row.shipmentPrice}</TableCell>
                      {/* <TableCell align="center">{row.discountPrice}</TableCell> */}
                      <TableCell align="center">{row.count}</TableCell>
                      <TableCell align="center">
                        {row.exist ? "موجود" : "ناموجود"}
                      </TableCell>
                      <TableCell align="center">{row.gift}</TableCell>

                      <TableCell align="center" style={{ width: "105px" }}>
                        <DeleteIcon
                          className="deleteIcon"
                          onClick={() => this.handlePrepareDelete(row.id)}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
                {this.emptyRows > 0 && (
                  <TableRow style={{ height: 49 * this.emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
          {this.state.loading && (
            <CircularProgress size={24} className="buttonProgress" />
          )}
          <TablePagination
            rowsPerPageOptions={[10, 20, 50]}
            component="div"
            count={this.state.rowsLength}
            rowsPerPage={this.state.rowsPerPage}
            page={this.state.page}
            backIconButtonProps={{
              "aria-label": "previous page",
            }}
            nextIconButtonProps={{
              "aria-label": "next page",
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </Paper>
        <AlertDialog
          open={this.state.alertDialog}
          title={`اخطار`}
          body={`آیا از حذف محصول اطمینان دارید؟`}
          handleYes={this.handleDelete}
          handleNo={this.handleCloseDialog}
        />
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          autoHideDuration={3000}
          open={this.state.openSnackbar}
          ContentProps={{
            "aria-describedby": "message-id",
            class:
              "error MuiTypography-root MuiPaper-root MuiPaper-elevation6 MuiSnackbarContent-root MuiTypography-body2",
          }}
          message={<span id="message-id"> {this.state.errorMessage} </span>}
          onClose={() => this.handleCloseSnackbar(false)}
        />
      </div>
    );
  }
}
